import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translateHowToPlay from './translateHowToPlay';
import translateGameRules from './translateGameRules';
import translateHeader from './translateHeader.js';
import translateProvablyFairSettings from './translateProvablyFairSettings.js';
import provablyFair from './provablyFair.js';
import freeBets from './freeBets.js'
import general from './general.js';


i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: {
                    ...translateHowToPlay.en,
                    ...translateGameRules.en,
                    ...translateHeader.en,
                    ...translateProvablyFairSettings.en,
                    ...provablyFair.en,
                    ...freeBets.en,
                    ...general.en,
                },
            },

        ru: {
            translation: {
                ...translateHowToPlay.ru,
                ...translateGameRules.ru,
                ...translateHeader.ru,
                ...translateProvablyFairSettings.ru,
                ...provablyFair.ru,
                ...freeBets.ru,
                ...general.ru,
            },
        },
        uz: {
            translation: {
                ...translateHowToPlay.uz,
                ...translateGameRules.uz,
                ...translateHeader.uz,
                ...translateProvablyFairSettings.uz,
                ...provablyFair.uz,
                ...freeBets.uz,
                ...general.uz,
                },
            },
        },
    lng: "uz",
    fallbackLng: "uz",
    interpolation: { escapeValue: false },
});

export default i18n;